import { getReleaseNotes as getClimateNotes } from '@oaknorth/climate';
import { ReleaseNotesPage } from '@oaknorth/component-release-notes';
import { getReleaseNotes as getMonitoringNotes } from '@oaknorth/monitoring';
import { getReleaseNotes as getScenariosNotes } from '@oaknorth/scenarios';
import { useFlag } from '@oaknorth/util-feature-flags';
import { T } from '@oaknorth/util-intl';

import { FeatureFlag } from '../constants';

function isNotNull<T>(value: T | null): value is T {
  return !(value === null);
}

export function useNoteDefinitions() {
  const hasScenariosFeature = useFlag<boolean>(FeatureFlag.HAS_SCENARIOS);
  const hasMonitoringFeature = useFlag<boolean>(FeatureFlag.HAS_MONITORING);
  const hasClimateFeature = useFlag<boolean>(FeatureFlag.HAS_CLIMATE);

  return [
    hasScenariosFeature
      ? {
          id: 'scenarios',
          label: T`scenarios.scenarioComparison.title`,
          getContent: getScenariosNotes,
        }
      : null,
    hasMonitoringFeature
      ? {
          id: 'monitoring',
          label: T`monitoring.title`,
          getContent: getMonitoringNotes,
        }
      : null,
    hasClimateFeature
      ? {
          id: 'climate',
          label: T`navBar.analysis.climate`,
          getContent: getClimateNotes,
        }
      : null,
  ].filter(isNotNull);
}

export function AppReleaseNotes() {
  const noteDefinitions = useNoteDefinitions();

  return <ReleaseNotesPage noteDefinitions={noteDefinitions} />;
}
